// extracted by mini-css-extract-plugin
export default {"tag":"ZJDXR","info":"mfB7S","text":"ApREi","warning":"dLyaV","success":"xO7Nj"};